// OrderManagement/UpdatePaymentStatus.jsx
import React, { useState } from "react";
import { Modal, Button, Form, Spinner, Alert } from "react-bootstrap";
import { useUpdatePaymentStatusMutation } from "../../Services/api";

const UpdatePaymentStatus = ({ show, handleClose, bookingId }) => {
  const [transactionId, setTransactionId] = useState("");
  const [hoverConfirm, setHoverConfirm] = useState(false);

  const [updatePaymentStatus, { isLoading, isError, error }] =
    useUpdatePaymentStatusMutation();

  const handleUpdate = async () => {
    if (!transactionId.trim()) return;
    try {
      await updatePaymentStatus({
        eventBookingId: bookingId,
        newTransactionId: transactionId.trim(),
      }).unwrap();
      setTransactionId("");
      handleClose(); // modal closes
      // No need to manually call refetch—cache invalidation does it for you
    } catch (err) {
      console.error("Update failed:", err);
    }
  };

  const onHide = () => {
    setTransactionId("");
    handleClose();
  };

  const confirmStyle = {
    backgroundColor: hoverConfirm ? "#333" : "#000",
    color: "#fff",
    border: "none",
    padding: "10px 40px",
    fontSize: "1rem",
    transition: "background-color 0.2s ease-in-out",
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="rounded-3"
    >
      <Modal.Header className="bg-white border-0">
        <Modal.Title className="mx-auto fw-bold text-dark">
          Update Payment
        </Modal.Title>
        <Button
          variant="light"
          onClick={onHide}
          className="position-absolute end-0 me-3"
          style={{ fontSize: "1.5rem", color: "red", lineHeight: 1 }}
        >
          ×
        </Button>
      </Modal.Header>

      <Modal.Body className="bg-white px-5 py-4">
        {isError && (
          <Alert variant="danger">
            {error?.data?.message || "Error updating payment status."}
          </Alert>
        )}
        <p className="text-center mb-4 text-dark">
          Enter the new Transaction ID below:
        </p>
        <Form.Group controlId="transactionInput">
          <Form.Control
            type="text"
            placeholder="Transaction ID"
            value={transactionId}
            onChange={(e) => setTransactionId(e.target.value)}
            className="form-control-lg shadow-sm"
            disabled={isLoading}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer className="bg-white border-0 px-5 pb-4 justify-content-center">
        <Button
          onClick={handleUpdate}
          disabled={!transactionId.trim() || isLoading}
          style={confirmStyle}
          onMouseEnter={() => setHoverConfirm(true)}
          onMouseLeave={() => setHoverConfirm(false)}
        >
          {isLoading ? <Spinner animation="border" size="sm" /> : "Confirm"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdatePaymentStatus;
